import { Products } from '@ori-ui/icons';
import { Avatar, Box, Link, styled, useTheme } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { useTranslations } from '../../hooks/useTranslations';
import { MenuItemTestIds, TranslationKey } from '../../models';

/**
 * Avatar size. Value is in pixels
 */
const AVATAR_SIZE = 28;
interface BaseLinkConfiguration {
  isEnabled: boolean;
  sharedUrl?: string | null;
}

export interface MenuItemPersonalLinksProps {
  personalProductListConfiguration?: BaseLinkConfiguration;
}

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[900],
}));

const StyledProducts = styled(Products)(({ theme }) => ({
  width: 22,
  height: 24,
  margin: theme.spacing(1.4, 0.6),
}));

export const LinkWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const Root = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6),
}));
const PersonalLink = styled(Link)(({ theme }) => ({
  color: theme.palette.common.black,
  textDecoration: 'underline',
  fontWeight: 'bold',
  fontSize: 14 /*  theme.typography.pxToRem(14) this seems to return 1.4 rem instead of 0.875 rem */,
}));

export const MenuItemPersonalLinks: FC<MenuItemPersonalLinksProps> = ({ personalProductListConfiguration }) => {
  const theme = useTheme();
  const { formatMessage } = useTranslations();
  const { getTestIdProps } = useTestId();

  return (
    <Root>
      {personalProductListConfiguration?.isEnabled && personalProductListConfiguration.sharedUrl ? (
        <LinkWrap sx={{ marginTop: theme.spacing(3.75) }}>
          <StyledProducts viewBox="2.8 4 16.5 16" />
          <PersonalLink
            href={personalProductListConfiguration.sharedUrl}
            {...getTestIdProps(MenuItemTestIds.RECOMMENDED_PRODUCTS)}
          >
            {formatMessage(TranslationKey.SeeMyFavoriteProducts)}
          </PersonalLink>
        </LinkWrap>
      ) : null}
    </Root>
  );
};
